import VantaHipaaBadgeImg from "../../assets/Vanta-HIPAA-Badge.png";

/**
 * Static "HIPAA — Powered by Vanta" badge.
 *
 * Replaces the retired Compliancy Group dynamic seal (the vendor
 * discontinued its Seal of Compliance program). The image itself is
 * static; live verification lives in the Vanta Trust Center the badge
 * links to — the same destination the SOC 2 badge already uses.
 */
const TRUST_CENTER_URL =
  "https://app.vanta.com/impiricus.com/trust/7j9de7fa6wru6k8fejvxj/controls";

interface VantaHipaaBadgeProps {
  /** When set, CSS classes control sizing (e.g. WPFooter); otherwise a default inline width applies. */
  className?: string;
  /** Rendered width in px when no className is given. */
  width?: number;
}

export default function VantaHipaaBadge({
  className,
  width = 114,
}: VantaHipaaBadgeProps) {
  return (
    <a
      href={TRUST_CENTER_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: "inline-block", lineHeight: 0 }}
    >
      <img
        src={VantaHipaaBadgeImg}
        alt="HIPAA — Powered by Vanta"
        className={className}
        style={
          className ? undefined : { display: "block", width, height: "auto" }
        }
        loading="lazy"
      />
    </a>
  );
}
